import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActionCreator from './../store/actions/index';
import { withRouter } from 'react-router-dom';
import { CssBaseline, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import OpenStreetMap from '../components/MapComponents/OpenStreetMap';
import CarList, { carListWidth } from '../components/MapComponents/CarList/CarList';
import MapTopBar from '../components/MapComponents/TopBar/MapTopBar';
import { defaultCenter } from "../components/MapComponents/MapComponent";

const StyledDiv = styled.div`
    overflow: hidden;
`;

const useStyles = (() => ({
    container: {
        display: "flex",
        height: "calc(100vh - 146px)",
    },
    mapContainer: {
        width: "80%"
    },
    listContainer: {
        minWidth: carListWidth,
        width: "20%"
    }
}));

const MapView = (props) => {
    const { classes } = props;
    const [filteredCars, setFilteredCars] = useState([]);
    const [currentZoom, setCurrentZoom] = useState(7);
    const [currentCenter, setCurrentCenter] = useState(defaultCenter);

    useEffect(() => {
        props.getPoiLocations();
    }, []);

    return (
        <StyledDiv>
            <MapTopBar
                filteredCars={filteredCars}
                zoom={currentZoom}
                center={currentCenter}
            />
            <div className={classes.container}>
                <CssBaseline />
                <div className={classes.listContainer}>
                    <CarList
                        onCarsChange={(data) => setFilteredCars(data)}
                    />
                </div>
                <div className={classes.mapContainer} >
                    <OpenStreetMap
                    onZoomChange={(zoom) => setCurrentZoom(zoom)}
                    onCenterChange={(center) => setCurrentCenter(center)} />
                </div>
            </div>
        </StyledDiv>
    );
};

MapView.propTypes = {
    classes: PropTypes.object,
    getPoiLocations: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    withStyles(useStyles),
    withRouter,
    connect(
        null,
        mapDispatchToProps
    )
)(MapView);
